import * as React from 'react';

import {
  Box,
  Button,
  Typography,
  IconButton,
  Menu,
  MenuItem
} from '@mui/material'

import { useSelector, useDispatch } from 'react-redux'
import { Droppable } from 'react-beautiful-dnd';
import axios from 'axios';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';

import PageCard from './PageCard';
import SlideModal from '../../modals/SlideModal'
import PresentationModal from '../../modals/PresentationModal';
import ScheduleModal from '../../modals/ScheduleModal';

import { deletePresentation, schedulePresentation, updatePresentation } from '../../slices/presentation';
import { API_URI } from '../../const';

const bgColor = ['#ECF2FF', '#E8F7FF', '#FEF5E5', '#E6FFFA'];

export default function Panel(props) {
  const {id, index, title, model, items} = props;  

  const [presentationId, setPresentationId] = React.useState('');
  const [openSlide, setOpenSlide] = React.useState(false);
  const [openSchedule, setOpenSchedule] = React.useState(false);
  const [openPresentation, setOpenPresentation] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const dispatch = useDispatch();


  const handleCloseSlide = () => {
    setOpenSlide(false);
  }

  const handleCreateSlide = (id) => {
    setOpenSlide(true);
    setPresentationId(id);
  }

  const handleCloseSetting = () => {
    setAnchorEl(null)
  }

  const handleEdit = () => {
    setOpenPresentation(true)
  }

  const handleRemove = () => {
    if(window.confirm('Do you really want to remove this presentation?')) {
      dispatch(deletePresentation({id}))
        .then(() => {
          window.alert('The presentation removed successfully.')
        })
        .catch(err =>
          console.log(err)
        )
    }
  }

  const handleGenerate = async () => {
    const token = localStorage.getItem("token");  

    const config = {  
      method: 'get',  
      url: `${API_URI}v1/user/presentation/${id}/generate`,  
      responseType: 'blob',  
      headers: {  
        Authorization: `Bearer ${token}`,  
        'ngrok-skip-browser-warning': true,        
        'Content-Type': 'application/json',  
      },  
    };  
  
    setLoading(true);  
  
    try {  
      const response = await axios.request(config);  
      const blob = response.data;  
  
      const url = window.URL.createObjectURL(blob);  
      const a = document.createElement('a');  
      a.href = url;  
      a.download = 'test.pptx';  
      document.body.appendChild(a);  
      a.click();  
      document.body.removeChild(a);  
  
      setLoading(false);  
    } catch (err) {  
      console.log(err);  
      window.alert("I can't generate the powerpoint for the prompts");  
      setLoading(false);  
    }  
  }

  const handleSchedule = async () => {
    setOpenSchedule(true);
  }

  const handleClosePresentation = () => {
    setOpenPresentation(false);
  }

  const handleSavePresentation = (title, model) => {
    dispatch(updatePresentation({id, title, model}))
    setOpenPresentation(false);
  }

  const handleSaveSchedule = async (title, recurrence, day, time, destination) => {
    dispatch(schedulePresentation({presentation: id, title, recurrence, day: String(day), time, destinations: [destination]}))
  }

  return (  
    <Box sx={{ minWidth: 280, width: 280, boxSizing: 'border-box', background: bgColor[index%4], borderRadius: 2, maxHeight: '100%', paddingY: 2, paddingX: 3 }}>
      <Droppable droppableId={String(id)}>
      {(provided, snapshot) => (  
        <div 
          ref={provided.innerRef} 
          {...provided.droppableProps}
        >  
          <Box className="flex flex-row align-center" sx={{ marginBottom: 2 }}>  
            <Typography sx={{ flexGrow: 1 }}>{title}</Typography>  
            <IconButton 
              sx={{ flexGrow: 0 }}
              onClick={() => handleCreateSlide(id)}
            >
              <AddIcon fontSize="small" />  
            </IconButton>  
            <IconButton 
              sx={{ flexGrow: 0 }}
              onClick={(e) => setAnchorEl(e.currentTarget)}
            >  
              <MoreVertIcon fontSize="small" />  
            </IconButton>
          </Box>  
          <Box className="h-full" sx={{ maxHeight: '100%' }}>  
            {items.map((item, i) => (
              <PageCard 
                pId={id}
                id={item.id}
                key={item.id}
                index={i}
                title={item.title}
                source={item.source}
                prompt={item.prompt}
                query={item.query}
                comment={item.comment}
                isComment={item.has_comment}
                data={item.data}
                visualization={item.visualization}
              />
            ))}
          </Box>  
          {provided.placeholder}  
        </div>  
      )}
      </Droppable>
      <SlideModal
        open={openSlide}
        pId={presentationId}
        defaultVisualization={'table'}
        defaultDatabase={''}
        defaultTitle={''}
        defaultPrompt={''} 
        defaultComment={false}
        handleClose={handleCloseSlide}
      />
      <PresentationModal
        open={openPresentation}
        defaultTitle={title}
        defaultModel={model}
        handleSave={handleSavePresentation}
        handleClose={handleClosePresentation}
      />
      <ScheduleModal
        open={openSchedule}
        id={id}
        type={'presentation'}
        handleSave={handleSaveSchedule}
        handleClose={() => setOpenSchedule(false)}
      />
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleCloseSetting}
        onClick={handleCloseSetting}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '& .MuiList-root': {
              py: '4px'
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              left: 12,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      >
        <MenuItem sx={{fontSize: '0.875rem'}} onClick={handleGenerate}>
          Generate
        </MenuItem>
        <MenuItem sx={{fontSize: '0.875rem'}} onClick={handleSchedule}>
          Schedule
        </MenuItem>
        <MenuItem sx={{fontSize: '0.875rem'}} onClick={handleEdit}>
          Edit
        </MenuItem>
        <MenuItem sx={{fontSize: '0.875rem'}} onClick={handleRemove}>
          Remove
        </MenuItem>
      </Menu>
    </Box>  
  )  
}  